<template>
    <div id="image-tool" class="image-tool">
        <div style="padding-bottom: 20px;">
            <stage v-if="imagePath !== ''"></stage>
        </div>
<!--        <hr>-->
<!--        <div>-->
<!--            <close-ups -->
<!--                @add-image="showDropzone = true"-->
<!--                @refresh="getData">-->
<!--            </close-ups>-->
<!--        </div>-->
<!--        <transition name="fade">-->
<!--            <div -->
<!--                class="dropzone-overlay" -->
<!--                v-if="showDropzone"-->
<!--                >-->
<!--                <dropzone-->
<!--                    @close="showDropzone = false"-->
<!--                    @refresh="getData"-->
<!--                ></dropzone>-->
<!--            </div>-->
<!--        </transition>-->
        
    </div>
</template>

<script>
import Stage from './views/Stage';
// import CloseUps from './components/CloseUps';
// import Dropzone from './components/Dropzone';
import { mapState } from 'vuex';
import * as types from './store/types';

export default {
    data() {
        return {
            showDropzone: false
        }
    },
    computed: {
        ...mapState({
            imagePath: state => state.imagePath
        })
    },
    methods: {
        async getData() {
            const url = `${this.$baseUrl}/${this.$id}`;

            try {
                const response = await fetch(url, {
                    method: 'GET'
                });
                const result = await response.json();

                await this.$store.dispatch(types.SET_IMAGEDATA, result.imageData);
                await this.$store.dispatch(types.SET_IMAGE_PATH, result.imagePath);
            } catch (error) {
                console.log(error);
            }
        },
    },
    components: {
        Stage
        // CloseUps,
        // Dropzone
    },
    created() {
        this.getData();
    }
}
</script>

<style lang="scss" scoped>
.image-tool {
    position: relative;
}

.dropzone-overlay {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    backdrop-filter: blur(2px);
    display: flex;
    justify-content: center;
    align-items: center;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}
</style>
